// ─────────────────────────────────────────────────────────────────────────────
// FEATURE: Menu  (pack sizes)
// The pack sizes a catch can be bought in. Every catch is priced per kg (data/seafood.ts), so a pack costs
// its share of the per-kg price — 500 g is half, 1 kg is the full price. There is NO bulk discount, "saving"
// or strike-through price, because none exists; don't display one. Add a size here to offer it everywhere
// (menu sheet, cart, checkout and order lines all derive from this list).
// ─────────────────────────────────────────────────────────────────────────────
import { parsePriceToNumber } from "../utils/priceFormat";
import type { SeafoodItem } from "./seafood";

export type PackId = "500g" | "1kg";

export interface PackSize {
  id: PackId;
  /** How it is written to customers, e.g. "500 g". */
  label: string;
  kg: number;
}

export const PACK_SIZES: PackSize[] = [
  { id: "500g", label: "500 g", kg: 0.5 },
  { id: "1kg", label: "1 kg", kg: 1 },
];

/** The pack a cart line without one (saved before packs existed, when quantities were in kg) counts as. */
export const LEGACY_PACK: PackId = "1kg";

export const packById = (id: PackId): PackSize => PACK_SIZES.find((pack) => pack.id === id) ?? PACK_SIZES[PACK_SIZES.length - 1];

export const isPackId = (value: unknown): value is PackId => PACK_SIZES.some((pack) => pack.id === value);

/** What one pack of this catch costs, in rupees. */
export function packPrice(item: SeafoodItem, pack: PackSize): number {
  return Math.round(parsePriceToNumber(item.price) * pack.kg);
}

/** The per-100 g rate — the same for every pack, since pricing is linear. */
export function pricePer100g(item: SeafoodItem): number {
  return parsePriceToNumber(item.price) / 10;
}
